// src/components/SalidaEntradaPatrones/StatusBadge.jsx
import React from 'react';
import { Badge } from 'react-bootstrap';
import { FaCheckCircle, FaTimesCircle, FaClock, FaExclamationTriangle } from 'react-icons/fa';

/**
 * Componente para mostrar badges de estado con colores consistentes
 */
const StatusBadge = ({ type, status, text, size = 'md' }) => {
  const getConfig = () => {
    // Estados de patrones
    if (type === 'patron') {
      switch (status) {
        case 'disponible':
        case 'Activo':
          return { bg: 'success', icon: <FaCheckCircle />, text: text || 'Disponible' };
        case 'en-servicio':
        case 'inService':
          return { bg: 'danger', icon: <FaTimesCircle />, text: text || 'En Servicio' };
        case 'Inactivo':
          return { bg: 'secondary', icon: <FaExclamationTriangle />, text: text || 'Inactivo' };
        case 'Mantenimiento':
          return { bg: 'warning', icon: <FaClock />, text: text || 'Mantenimiento' };
        default:
          return { bg: 'secondary', icon: null, text: status };
      }
    }

    // Estados de movimientos
    if (type === 'movimiento') {
      switch (status) {
        case 'open':
        case 'abierto':
          return { bg: 'success', icon: <FaCheckCircle />, text: text || 'Abierto' };
        case 'closed':
        case 'cerrado':
          return { bg: 'danger', icon: <FaTimesCircle />, text: text || 'Cerrado' };
        default:
          return { bg: 'secondary', icon: null, text: status };
      }
    }

    // Estados de OTs
    if (type === 'ot') {
      switch (status) {
        case 'pending':
        case 'pendiente':
          return { bg: 'warning', icon: <FaClock />, text: text || 'Pendiente' };
        case 'in-progress':
        case 'en-progreso':
          return { bg: 'primary', icon: <FaClock />, text: text || 'En Progreso' };
        case 'completed':
        case 'completada':
          return { bg: 'success', icon: <FaCheckCircle />, text: text || 'Completada' };
        default:
          return { bg: 'secondary', icon: null, text: status };
      }
    }

    // Default
    return { bg: 'secondary', icon: null, text: text || status };
  };

  const config = getConfig();
  const fontSize = size === 'sm' ? '0.75rem' : size === 'lg' ? '1rem' : '0.875rem';

  return (
    <Badge bg={config.bg} className="d-inline-flex align-items-center gap-1" style={{ fontSize }}>
      {config.icon && <span>{config.icon}</span>}
      <span>{config.text}</span>
    </Badge>
  );
};

export default StatusBadge;
